<template>
  <div>
    <div class="sm:text-sm text-xs">
      <div
        class="w-full flex cursor-pointer sm:rounded-t-md rounded-md mb-4 sm:mb-0 yazio-author-categories"
        style="background-color: #9686c9"
      >
        <div
          class="sm:w-1/12 w-1/4 u-center flex-col text-white text-center"
          :class="{ 'bg-white-10': selectedCategory === null }"
          @click="changeCategory(null)"
        >
          <OIcon :icon="`yazio/tumu`" svg-class="mb-1.5 text-white yazio-category-icon" />
          Tümü
        </div>
        <div
          v-for="category in isMobile ? categories.slice(0, 2) : categories.slice(0, 10)"
          :key="category"
          class="sm:w-1/12 w-1/4 u-center flex-col text-white text-center"
          :class="{ 'bg-white-10': selectedCategory === category }"
          @click="changeCategory(category)"
        >
          <OIcon :icon="`yazio/${normalizeText(category)}-white`" svg-class="mb-1.5 text-white yazio-category-icon" />
          {{ category }}
        </div>
        <div class="sm:w-1/12 w-1/4 u-center flex-col text-white text-center relative" @click="toggleAllCategories">
          <OIcon :icon="`yazio/kategoriler`" svg-class="mb-1.5 text-white yazio-category-icon" />
          Kategoriler
          <OIcon icon="caret-down" class="w-4 absolute bottom-[1px]" />
        </div>
      </div>
    </div>
    <div class="sm:px-6 sm:pt-6 sm:bg-white mb-44 flex flex-wrap rounded-b-md relative">
      <div
        v-if="showAllCategories"
        class="absolute top-0 left-0 right-0 px-6 pt-6 bg-white flex flex-wrap sm:rounded-b-md z-2 yazio-other-categories rounded-md"
      >
        <div
          v-for="category in isMobile ? categories.slice(2) : categories.slice(10)"
          :key="category"
          class="sm:w-1/4 w-full mb-6 u-center sm:flex-col justify-start yazio-other-icon text-sm"
          :class="{ active: selectedCategory === category }"
          @click="changeCategory(category)"
        >
          <OIcon :icon="`yazio/${normalizeText(category)}`" svg-class="sm:mb-1.5 mr-2 sm:mr-0 text-white" />
          {{ category }}
        </div>
      </div>
      <YazioAuthorItem
        v-for="author in filteredAuthors"
        :key="author._id"
        :item="author"
        class="sm:w-1/4 sm:mb-6 w-full mb-2 bg-white sm:bg-transparent"
      />
    </div>
  </div>
</template>
<script>
import { defineComponent, ssrRef, ref, computed } from '@nuxtjs/composition-api';
import { shuffle } from 'lodash';
import YazioAuthorItem from './YazioAuthorItem';
import { normalizeText } from '~/modules/common/utils/stringUtils';
import { useDevice } from '~/composables/useDevice';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { YazioAuthorItem, OIcon },
  props: {
    authors: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const allAuthors = ssrRef([], 'yazioAllAuthors');
    const categories = ssrRef([]);
    const selectedCategory = ref(null);
    const showAllCategories = ref(false);
    if (process.server) {
      allAuthors.value = shuffle(props.authors);
      categories.value = shuffle([...new Set(props.authors.map((author) => author.category).filter((cat) => cat))]);
    }
    const filteredAuthors = computed(() =>
      selectedCategory.value ? allAuthors.value.filter((author) => author.category === selectedCategory.value) : allAuthors.value
    );
    const changeCategory = (category) => {
      const categoryIndex = categories.value.findIndex((cat) => cat === category);
      const categoryLimit = computed(() => (isMobile.value ? 2 : 10));
      if (categoryIndex >= categoryLimit.value) {
        const newCategories = categories.value.filter((cat) => cat !== category);
        newCategories.unshift(category);
        categories.value = newCategories;
      }
      selectedCategory.value = category;
      showAllCategories.value = false;
    };

    const toggleAllCategories = () => {
      showAllCategories.value = !showAllCategories.value;
    };

    return {
      normalizeText,
      categories,
      filteredAuthors,
      selectedCategory,
      changeCategory,
      showAllCategories,
      toggleAllCategories,
      isMobile,
    };
  },
});
</script>
<style lang="scss">
.yazio-author-categories {
  height: 76px;
}
.yazio-other-categories {
  box-shadow: 0px 1px 15px rgba(191, 200, 225, 0.5);
}

.yazio-category-icon {
  path {
    fill: #fff;
  }
}

.yazio-other-icon {
  cursor: pointer;
  path {
    fill: #424242;
  }
  &.active {
    color: #9686c9;
    path {
      fill: #9686c9;
    }
  }
  &:hover {
    color: #9686c9;
    path {
      fill: #9686c9;
    }
  }
}
</style>
